import { render } from "./ConfiguracionPlan.vue?vue&type=template&id=54b7ec79&scoped=true"
import script from "./ConfiguracionPlan.vue?vue&type=script&lang=js"
export * from "./ConfiguracionPlan.vue?vue&type=script&lang=js"

import "./ConfiguracionPlan.vue?vue&type=style&index=0&id=54b7ec79&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b7ec79"]])

export default __exports__